module.exports = __webpack_public_path__ + "media/images/help/browse_img_2-d3fb728ba88ce40cb5c3dbb221d8c5f8.jpeg";